import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const CreatePage = ({ initialData, initialDefaults, onSuccess, onError }) => {
    const API_URL = '/permission';

    // State untuk menyimpan form data. Jika initialData tersedia, isi form untuk update
    const [formData, setFormData] = useState({
        // Tambahkan inisialisasi untuk semua field yang diperlukan
        display_name: initialDefaults?.display_name || '',
        name: initialDefaults?.name || '',
        group: initialDefaults?.group || '',
    });

    const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

    // API hook untuk create dan update
    const { createData: createProduct } = useCreateData(API_URL, 'permissions');
    const { updateData: updateProduct } = useUpdateData(`${API_URL}/${initialData?.id}`, 'permissions');

    // Gunakan hook untuk menangani perubahan form
    const handleChange = useFormChangeHandler(setFormData);

    // Gunakan hook untuk menangani pengiriman form
    const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
        isUpdateMode ? updateProduct : createProduct,
        onSuccess,
        onError
    );

    useEffect(() => {
        // Jika data produk berubah (untuk update), isi ulang form data
        if (initialData) {
            setFormData(initialData); // Sesuaikan dengan struktur initialData
        } else if (initialDefaults) {
            setFormData((prev) => ({
                ...prev,
                display_name: initialDefaults.display_name || '',
                name: initialDefaults.name || '',
                group: initialDefaults.group || '',
            }));
        }
    }, [initialData, initialDefaults]);

    return (
        <form onSubmit={(e) => handleSubmit(formData, e)} className="d-flex flex-column" style={{ height: '100%' }}>
            <div className="action-sheet-content flex-grow-1">
                <div className="row mb-3 align-items-center">
                    <label htmlFor="display_name" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Display Name:</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control gotra-form-control rounded-1", formError?.display_name && 'is-invalid')}
                            id="display_name"
                            placeholder="Display Name"
                            name="display_name"
                            value={formData.display_name}
                            onChange={handleChange}
                            disabled={isSubmitting}
                            style={{ fontSize: '14px', height: '35px' }}
                        />
                        {formError?.display_name && <div className="invalid-feedback">{formError.display_name}</div>}
                    </div>
                </div>
                <div className="row mb-3 align-items-center">
                    <label htmlFor="name" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Name:</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control gotra-form-control rounded-1", formError?.name && 'is-invalid')}
                            id="name"
                            placeholder="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            disabled={isSubmitting}
                            style={{ fontSize: '14px', height: '35px' }}
                        />
                        {formError?.name && <div className="invalid-feedback">{formError.name}</div>}
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <label htmlFor="group" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Group:</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control gotra-form-control rounded-1", formError?.group && 'is-invalid')}
                            id="group"
                            placeholder="Group"
                            name="group"
                            value={formData.group}
                            onChange={handleChange}
                            disabled={isSubmitting}
                            style={{ fontSize: '14px', height: '35px' }}
                        />
                        {formError?.group && <div className="invalid-feedback">{formError.group}</div>}
                    </div>
                </div>
            </div>

            <div className="form-group mt-auto d-grid">
                <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
                    {isUpdateMode ? 'Update Permission' : 'Create Permission'}
                </button>
            </div>
        </form>
    );
};

export default CreatePage;
